/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `DR` - Draft
 * `PE` - Pending Approval
 * `AC` - Active
 * `FULFILLED` - Fulfilled
 * `RE` - Rejected
 * `VO` - Void
 */
export type OrderState = (typeof OrderState)[keyof typeof OrderState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderState = {
  DR: 'DR',
  PE: 'PE',
  AC: 'AC',
  FULFILLED: 'FULFILLED',
  RE: 'RE',
  VO: 'VO',
} as const;
